/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1FeedbackId202,
  PutApiV1FeedbackId400,
  PutApiV1FeedbackId401,
  PutApiV1FeedbackId404,
  PutApiV1FeedbackId500,
  PutApiV1FeedbackIdMutationRequest,
  PutApiV1FeedbackIdMutationResponse,
  PutApiV1FeedbackIdPathParams,
} from "../../types/feedbackRegistroController/PutApiV1FeedbackId.ts";
import { feedbackViewModelSchema } from "../feedbackViewModelSchema.ts";
import { updateFeedbackRequestViewModelSchema } from "../updateFeedbackRequestViewModelSchema.ts";

export const putApiV1FeedbackIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1FeedbackIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const putApiV1FeedbackId202Schema = z.lazy(
  () => feedbackViewModelSchema,
) as unknown as ToZod<PutApiV1FeedbackId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1FeedbackId400Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1FeedbackId401Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1FeedbackId404Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1FeedbackId500Schema =
  z.any() as unknown as ToZod<PutApiV1FeedbackId500>;

export const putApiV1FeedbackIdMutationRequestSchema = z.lazy(
  () => updateFeedbackRequestViewModelSchema,
) as unknown as ToZod<PutApiV1FeedbackIdMutationRequest>;

export const putApiV1FeedbackIdMutationResponseSchema = z.lazy(
  () => putApiV1FeedbackId202Schema,
) as unknown as ToZod<PutApiV1FeedbackIdMutationResponse>;
